import { notFlag } from "../components/filters/forms/filters.constants";

interface TParamMap {
  [param: string]: string;
}

const mapParameters = (
  params: any,
  map: TParamMap,
  returnString: boolean = true
): string | object => {
  if (!params) {
    if (returnString) {
      return "";
    } else {
      return {};
    }
  }

  const query: any = {};
  const paramMap: TParamMap = {
    limit: "limit",
    page: "offset",
    ordering: "ordering",

    ...map,
  };

  Object.keys(paramMap).forEach((param) => {
    if (param === "page" && params[param]) {
      query.offset = [(params.page[0] - 1) * params.limit[0]];
    } else if (params[param]) {
      let not = "";
      let value = params[param];

      if (
        typeof params[param][0] === "string" &&
        params[param][0].substr(0, notFlag.length) === notFlag
      ) {
        not = "__ne";
        value = [params[param][0].replace(notFlag, "")];
      }

      query[`${paramMap[param]}${not}`] = value;
    }
  });

  if (!returnString) {
    return query;
  }

  let queryString = Object.keys(query)
    .map((k) => query[k].map((v: string) => `${k}=${v}`).join("&"))
    .join("&");

  if (queryString !== "") {
    queryString = `?${queryString}`;
  }

  return queryString;
};

export default mapParameters;
